import { useEffect, useState } from 'react';
import { toast } from '../../../../core/components/atoms/Toast';
import { deckService } from '../../queries';
import useUserMemory from '../use-user-memory';

const useDeck = ({ deckUuid }: { deckUuid: string }) => {
  const { memoryUserUuid } = useUserMemory();

  const userUuid = memoryUserUuid;

  const [deck, setDeck] = useState<Deck>();
  const [isLoading, setIsLoading] = useState(false);

  const fetchDeck = async () => {
    if (!userUuid || !deckUuid) return;
    try {
      setIsLoading(true);
      const deck = await deckService.get({ deckUuid, userUuid });
      setDeck(deck);
    } catch (error) {
      console.error(error);
      toast({
        title: 'Erro ao buscar decks',
        message: 'Tente novamente mais tarde',
        variant: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDeck();
  }, [userUuid, deckUuid]);

  return {
    deck,
    fetchDeck,
    isLoading,
  };
};

export default useDeck;
